import SearchBox, {SearchBoxProps} from '@gaia/components/SearchBox';
import {LngLat} from 'mapbox-gl';
import {useCallback} from 'react';
import type {SuggestionSelectedEventData} from 'react-autosuggest';

export interface SearchBoxControlProps extends Omit<SearchBoxProps, 'onSearchResultSelected'> {
    setSelections: SetState<SelectionState[]>;
    onSidebarChange: SetState<SidebarState>;
    interactionType: InteractionState['type'];
    onInteractionChange: SetState<InteractionState>;
    map: mapboxgl.Map | undefined;
}

export function SearchBoxControl({
    onSidebarChange,
    setSelections,
    interactionType,
    onInteractionChange,
    map,
    ...props
}: SearchBoxControlProps) {
    const onSearchResultSelected = useCallback(
        (event: React.FormEvent<any>, data: SuggestionSelectedEventData<SearchResult>) => {
            const searchResult: SearchResult = data.suggestion;
            if (searchResult.osm_id) {
                setSelections([
                    {
                        type: 'osm',
                        lngLat: LngLat.convert(searchResult.location),
                        properties: searchResult,
                        title: searchResult.title,
                        osmId: searchResult.osm_id,
                    },
                ]);
                onSidebarChange({type: 'selection'});
                onInteractionChange((nextInteractionState) => ({
                    ...nextInteractionState,
                    markedLocation: undefined,
                }));
            } else if (searchResult.known_route_id) {
                setSelections([
                    {
                        type: 'knownRoute',
                        knownRouteId: searchResult.known_route_id,
                    },
                ]);
                onSidebarChange({type: 'knownRoute'});
                onInteractionChange((nextInteractionState) => ({
                    ...nextInteractionState,
                    markedLocation: undefined,
                }));
            } else if (interactionType === 'normal') {
                onSidebarChange({
                    type: 'disambiguation',
                    coordinates: searchResult.location,
                    title: searchResult.title,
                    features: [],
                });
            }
            map?.flyTo({
                center: searchResult.location,
                zoom: 16,
                duration: 250,
            });
        },
        [onSidebarChange, onInteractionChange, setSelections, interactionType, map]
    );

    return <SearchBox {...props} onSearchResultSelected={onSearchResultSelected} />;
}
